import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Stack } from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { LocationViewSelector } from "./LocationViewSelector";

interface LocationNavigationHeaderProps {
  locationName: string;
  locationId: string;
  locationType: "hangar" | "ramp";
  isSchedulingEnabled?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
  rightActions?: React.ReactNode;
}

export const LocationNavigationHeader: React.FC<
  LocationNavigationHeaderProps
> = ({
  locationName,
  locationId,
  locationType,
  isSchedulingEnabled = false,
  showBackButton = true,
  onBack,
  rightActions,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ width: "100%" }}
    >
      {/* Back button */}
      {showBackButton && (
        <IconButton
          onClick={handleBack}
          sx={{
            alignSelf: "flex-start", // Align to top to match with chips
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}

      {/* Location selector - takes remaining space */}
      <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
        <LocationViewSelector
          locationName={locationName}
          locationId={locationId}
          locationType={locationType}
          isSchedulingEnabled={isSchedulingEnabled}
        />
      </Box>

      {/* Optional right-side actions */}
      {rightActions && (
        <Box sx={{ alignSelf: "flex-start" }}>{rightActions}</Box>
      )}
    </Stack>
  );
};
